import { render, staticRenderFns } from "./SpouseDetail.vue?vue&type=template&id=696f6918&scoped=true&"
import script from "./SpouseDetail.vue?vue&type=script&lang=js&"
export * from "./SpouseDetail.vue?vue&type=script&lang=js&"
import style0 from "./SpouseDetail.vue?vue&type=style&index=0&id=696f6918&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696f6918",
  null
  
)

export default component.exports